import { useEffect } from 'react'

interface UsePreventManualScrollOptions {
  enabled: boolean
  allowScrollInSelector?: string
}

export const usePreventManualScroll = ({
  enabled,
  allowScrollInSelector = '[class*="tip"]',
}: UsePreventManualScrollOptions) => {
  useEffect(() => {
    if (!enabled) return

    const preventTouchScroll = (e: TouchEvent) => {
      const target = e.target as HTMLElement
      const scrollableContent = target.closest(allowScrollInSelector)
      if (!scrollableContent) {
        e.preventDefault()
      }
    }

    const preventWheelScroll = (e: WheelEvent) => {
      const target = e.target as HTMLElement
      const scrollableContent = target.closest(allowScrollInSelector)
      if (!scrollableContent) {
        e.preventDefault()
      }
    }

    const preventKeyboardScroll = (e: KeyboardEvent) => {
      const scrollKeys = ['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' ']
      if (scrollKeys.includes(e.key)) {
        e.preventDefault()
      }
    }

    document.addEventListener('touchmove', preventTouchScroll, { passive: false })
    document.addEventListener('wheel', preventWheelScroll, { passive: false })
    document.addEventListener('keydown', preventKeyboardScroll)

    return () => {
      document.removeEventListener('touchmove', preventTouchScroll)
      document.removeEventListener('wheel', preventWheelScroll)
      document.removeEventListener('keydown', preventKeyboardScroll)
    }
  }, [enabled, allowScrollInSelector])
}
